import { Layout } from '../../components/Layout/Layout';
import AlarmSelectGroup from '../../containers/Alarm/AlarmSelectGroup';
import { translate } from '../../utils/translate';
import { useAlarmStep } from '../../utils/customHooks/useAlarmStep';
import { AlarmStep } from '../../utils/enums';
function AlarmSelectGroupPage() {
  const { currentStep, link, stepsAmount } = useAlarmStep(AlarmStep.SelectGroups);
  return (
    <Layout
      isMessageLayout
      to={link}
      backBtn
      isAlarmCreateLayout
      message={`alarm_send_alarm`}
      subMessageText={`${translate(`alarm_step`)} ${currentStep} ${translate(
        `alarm_of`
      )} ${stepsAmount}`}
    >
      <AlarmSelectGroup isLastStep={currentStep === stepsAmount} />
    </Layout>
  );
}

export default AlarmSelectGroupPage;
